import { Box, FilledInput, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { colors } from 'Constants/Colors';

interface Props {
  onChange?: (value: string) => void;
  onBlur?: () => void;
  value?: string;
  name?: string;
  label?: string;
  options: {
    id: string;
    name: string;
  }[];
}

const SelectField = ({ onChange, onBlur, value = '', name, options, label }: Props) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Box>
      {label && (
        <Typography variant="body2" fontWeight="bold" mb={0.5}>
          {label}
        </Typography>
      )}
      <FormControl sx={{ minWidth: 200 }}>
        <Select
          displayEmpty
          value={value}
          onChange={handleChange}
          input={
            <FilledInput
              disableUnderline
              style={{ backgroundColor: colors.WHITE, border: `1px solid ${colors.GRAY_TEXT_FIELD}` }}
              sx={{ '& .MuiFilledInput-input': { paddingTop: '10px', paddingBottom: '10px' } }}
            />
          }
          name={name}
          onBlur={onBlur}
          MenuProps={{
            sx: {
              '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: `${colors.GREEN} !important`,
                color: `${colors.WHITE} !important`,
              },
              '& .MuiMenuItem-root:not(.Mui-selected):hover, & .MuiMenuItem-root:not(.Mui-selected).Mui-focusVisible': {
                backgroundColor: `${colors.GREEN_ULTRA_LIGHT} !important`,
              },
            },
          }}
          renderValue={selected => {
            const option = options.find(opt => opt.id === selected);
            return (
              <Typography variant="body1" fontWeight="bold">
                {option ? option.name : 'Todos'}
              </Typography>
            );
          }}
        >
          <MenuItem value="">
            <Typography variant="body1">Todos</Typography>
          </MenuItem>
          {options.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>
              <Typography variant="body1">{opt.name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectField;
